import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Terminal, KeyRound, LoaderCircle } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/AuthContext";

export default function Login() {
    const { authState, login } = useAuth();
    const nav = useNavigate();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    if (authState === "authed") return <Navigate to="/" replace />;

    const submit = async (e) => {
        e.preventDefault();
        if (!password) return;
        setLoading(true);
        try {
            await login(password);
            toast.success("Authenticated");
            nav("/", { replace: true });
        } catch (err) {
            toast.error(
                err?.response?.data?.detail || "Login failed",
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid-backdrop flex items-center justify-center px-6">
            <div
                className="panel p-8 w-full max-w-md fade-in"
                data-testid="login-panel"
            >
                <div className="flex items-center gap-3 mb-6">
                    <Terminal size={18} style={{ color: "var(--accent)" }} />
                    <span
                        className="mono text-[10px] uppercase tracking-[0.25em]"
                        style={{ color: "var(--text-faint)" }}
                    >
                        webhook.relay / admin
                    </span>
                </div>
                <h1
                    className="text-3xl font-semibold tracking-tight mb-1 term-glow"
                    style={{ color: "var(--text)" }}
                >
                    <span style={{ color: "var(--accent)" }}>$</span> login
                </h1>
                <p
                    className="text-sm mb-6"
                    style={{ color: "var(--text-dim)" }}
                >
                    Enter the admin password to access channels, rules, and
                    settings.
                </p>
                <form onSubmit={submit} className="flex flex-col gap-4">
                    <label
                        className="mono text-[10px] uppercase tracking-[0.2em]"
                        style={{ color: "var(--text-faint)" }}
                    >
                        password
                    </label>
                    <div className="relative">
                        <KeyRound
                            size={14}
                            className="absolute left-3 top-1/2 -translate-y-1/2"
                            style={{ color: "var(--text-faint)" }}
                        />
                        <input
                            type="password"
                            autoFocus
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mono text-sm w-full pl-9 pr-3 py-2.5 rounded-md outline-none"
                            style={{
                                background: "#05080c",
                                border: "1px solid var(--border-strong)",
                                color: "var(--text)",
                            }}
                            data-testid="login-password-input"
                            placeholder="admin"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="pill-btn justify-center"
                        data-testid="login-submit-btn"
                    >
                        {loading ? (
                            <LoaderCircle size={14} className="animate-spin" />
                        ) : null}
                        {loading ? "authenticating…" : "authenticate"}
                    </button>
                </form>
                <div
                    className="mt-6 mono text-[10px] uppercase tracking-[0.2em] text-center"
                    style={{ color: "var(--text-faint)" }}
                >
                    dev default · admin · set ADMIN_PASSWORD in backend .env
                </div>
            </div>
        </div>
    );
}
